import React from 'react';
import { X, AlertTriangle } from 'lucide-react';

const ConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'danger' // 'danger', 'warning', 'info'
}) => {
  if (!isOpen) return null;

  const variantColors = {
    danger: {
      icon: 'text-danger-red',
      iconBg: 'bg-red-50 border-red-200',
      button: 'bg-danger-red hover:bg-red-700',
    },
    warning: {
      icon: 'text-amber-600',
      iconBg: 'bg-amber-50 border-amber-200',
      button: 'bg-amber-500 hover:bg-amber-600',
    },
    info: {
      icon: 'text-wasabi-600',
      iconBg: 'bg-wasabi-50 border-wasabi-200',
      button: 'bg-wasabi-500 hover:bg-wasabi-600',
    }
  };

  const colors = variantColors[variant];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white border border-line rounded-xl p-6 max-w-md w-full mx-4 shadow-xl">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-slate-400 hover:text-slate-700 transition-colors"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Icon */}
        <div className="flex items-center justify-center mb-4">
          <div className={`w-16 h-16 rounded-full border ${colors.iconBg} flex items-center justify-center`}>
            <AlertTriangle className={`w-8 h-8 ${colors.icon}`} />
          </div>
        </div>

        {/* Title */}
        <h3 className="text-xl font-bold text-slate-900 text-center mb-3">
          {title}
        </h3>

        {/* Message */}
        <p className="text-slate-600 text-center mb-6">
          {message}
        </p>

        {/* Buttons */}
        <div className="flex space-x-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 bg-white hover:bg-slate-50 text-slate-700 rounded-lg transition-all border border-slate-300 font-medium"
          >
            {cancelText}
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className={`flex-1 px-4 py-2 ${colors.button} text-white rounded-lg transition-all font-semibold`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
